import axios from 'axios'
import {
  get,
  post,
  update,
} from '../helpers'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchDatas(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        get('/laporan-jenis/list', queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchData(ctx, { id }) {
      return new Promise((resolve, reject) => {
        get(`/upt/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addData(ctx, userData) {
      return new Promise((resolve, reject) => {
        post('/upt', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateData(ctx, userData) {
      return new Promise((resolve, reject) => {
        update('/upt', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchDatasExcel(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        get('/laporan-status/exportExcelStatus', queryParams, { responseType: 'blob' })
          .then(response => resolve(response))
          .catch(error => reject(error))
        // axios.get('/laporan-status/exportExcelStatus',
        // { params: queryParams },
        // { responseType: 'blob' })
        //   .then(response => resolve(response))
        //   .catch(error => reject(error))
      })
    },
  },
}

// axios
// .get('/laporan-status/exportExcelStatus', { params: queryParams },{responseType : 'blob' })
// .then(response => resolve(response))
// .catch(error => reject(error))
// })
